import { Material, OutwardMaterial } from "./Material";

export class Outward{
  requestId: number;
  requestName: string;
  requestTypeId: number;
  requestTypeName: string;
  requestDateTime:string;
  returnDateTime: string;
  revisedDate:string
  receivedDate:string;
  remark: string;
  gatepassNumber: number;
  gatepassNo:string;
  serialNumber: string="";
  materialSentToVendorId: number;
  materialSentToVendorName: string;
  materialCarriedByVendorId: number;
  materialCarriedByVendorName: string;
  approverEmailL1: string;
  approverEmailL2: string;
  practiceId: number;
  practiceName: string;
  status: string;
  statusId: number;
  previousStatusId: number;
  isActive: boolean;
  cityId: number;
  cityName: string;
  officeId: number;
  officeName: string;
  authorizedBy:string;
  createdBy:string|null;
  declinedByNotes:string;
  cancelledByNotes:string;
  updatedBy:string|null;
  FirstName:string='';
  LastName:string='';
  l1ApprovedDateTime:string;
  l2ApprovedDateTime:string;
  purpose:string;
  materialList:OutwardMaterial[] = [];
  attachedFiles: { name: string, type?: string, data?: string | ArrayBuffer, requestType?: string }[];
  attachedFilesDetails: { name: string, type?: string, data?: string | ArrayBuffer, requestType?: string }[];
}